import React from 'react';

import { Tooltip } from 'e100-react-components';

import { makeStyles } from 'e100-react-components';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-block',
    maxWidth: '100%',

    '& > div': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    }
  },
}));

export const DataGridHeaderTooltipCell = ({
  name
}: DataGridTooltipCellProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Tooltip
        title={name}
        enterDelay={1000}
        enterNextDelay={1000}
        enterTouchDelay={0}
      >
        <>{name}</>
      </Tooltip>
    </div>
  );
};

interface DataGridTooltipCellProps {
  name: string;
}
